import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";

const AddSkill = ({
  options,
  selectedValues,
  onSelect,
  onDeselect,
  searchTerm,
  onSearchChange,
  placeholder = "Ara...",
  label,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownStyle, setDropdownStyle] = useState({});

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function updateDropdownPosition() {
      if (isOpen && containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        setDropdownStyle({
          position: "fixed",
          top: rect.bottom,
          left: rect.left,
          width: rect.width,
          zIndex: 9999,
        });
      }
    }
    if (isOpen) {
      updateDropdownPosition();
      window.addEventListener("scroll", updateDropdownPosition);
      window.addEventListener("resize", updateDropdownPosition);
    }
    return () => {
      window.removeEventListener("scroll", updateDropdownPosition);
      window.removeEventListener("resize", updateDropdownPosition);
    };
  }, [isOpen]);

  const dropdown = isOpen && (
    <div
      ref={dropdownRef}
      style={dropdownStyle}
      className="max-h-60 overflow-y-auto border border-[rgba(203,212,225,1)] rounded-lg bg-white shadow-lg"
    >
      {options.map((option) => {
        const optionValue = option.name || option;
        const isSelected = selectedValues.includes(optionValue);
        return (
          <div
            key={optionValue}
            className={`flex items-center p-3 cursor-pointer hover:bg-lighterGreen ${
              isSelected ? "" : ""
            }`}
            onClick={() => {
              isSelected ? onDeselect(optionValue) : onSelect(optionValue);
            }}
          >
            <div className="relative w-4 h-4 mr-3">
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => {}}
                className={`w-4 h-4 border-2 rounded appearance-none cursor-pointer transition-colors ${
                  isSelected
                    ? "border-greenn bg-greenn"
                    : "border-[rgba(203,212,225,1)]"
                }`}
              />
              {isSelected && (
                <svg
                  className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 text-dark font-bold pointer-events-none"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={4}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              )}
            </div>
            <span className="text-[rgba(100,116,139,1)]">{optionValue}</span>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className="form-group w-full" ref={containerRef}>
      {label && <label className="label-edit">{label}</label>}
      <div className="relative w-full">
        <input
          type="text"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          onFocus={() => setIsOpen(true)}
          className="custom-input w-full px-4 mb-2"
        />
        {ReactDOM.createPortal(dropdown, document.body)}
      </div>
    </div>
  );
};

export default AddSkill;
